<template>
  <TicketSidebarDetalleOperacion v-if="mostrarOperacion" :model="model" @ver-detalle="emit('ver-detalle-operacion')" />
  <TicketSidebarDetalleBorrador v-else-if="mostrarBorrador" :model="model" @ver-detalle="emit('ver-detalle-borrador')" />
  <TicketSidebarDetalleFactura v-else-if="mostrarFactura" :model="model" />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { TipoTicketEnum, type DetailTicketModel } from "@api/api";
import { EntidadTicketEnum } from "../models/EntidadTicketEnum";
import TicketSidebarDetalleOperacion from "./TicketSidebarDetalleOperacion.vue";
import TicketSidebarDetalleBorrador from "./TicketSidebarDetalleBorrador.vue";
import TicketSidebarDetalleFactura from "./TicketSidebarDetalleFactura.vue";

const props = defineProps<{
  model: DetailTicketModel;
}>();

const emit = defineEmits<{
  "ver-detalle-operacion": [];
  "ver-detalle-borrador": [];
}>();

const mostrarOperacion = computed((): boolean =>
  props.model.Tipo === TipoTicketEnum.Operaciones
  && !!props.model.EntidadesAsociadas?.[EntidadTicketEnum.Operacion]?.length
);

const mostrarBorrador = computed((): boolean =>
  props.model.Tipo === TipoTicketEnum.Operaciones
  && !!props.model.EntidadesAsociadas?.[EntidadTicketEnum.Borrador]?.length
);

const mostrarFactura = computed((): boolean =>
  props.model.Tipo === TipoTicketEnum.Facturas
  && !!props.model.EntidadesAsociadas?.[EntidadTicketEnum.Factura]?.length
);
</script>
